import { Link } from 'react-router-dom';
import Analytics from './Analytics';

export default function Dashboard({ reflections = [] }) {
  // Empty state
  if (!reflections || reflections.length === 0) {
    return (
      <div className="min-h-screen bg-stone-50 py-20 px-4">
        <div className="max-w-2xl mx-auto text-center pt-10">
          <div className="mb-8 animate-fadeIn">
            <div className="text-8xl mb-6">🌱</div>
            <h2 className="text-3xl font-light text-stone-800 mb-3">
              Your wellness journey starts here
            </h2>
            <p className="text-stone-500 text-lg mb-8 leading-relaxed max-w-lg mx-auto">
              Cultivate mindfulness. Begin your first check-in to unlock insights about your emotional patterns, mood trends, and cognitive growth.
            </p>
          </div>

          <Link
            to="/check-in"
            className="inline-block bg-emerald-500 text-white font-semibold py-4 px-10 rounded-full hover:bg-emerald-600 transition-all shadow-md hover:shadow-lg hover:-translate-y-1"
          >
            Start Your First Check-In
          </Link>
          
          <div className="mt-16 pt-12 border-t border-stone-200">
            <p className="text-stone-400 text-sm font-light">
              ✨ Every feeling is valid. Every day is a new start.
            </p>
          </div>
        </div>
      </div>
    );
  }

  const totalReflections = reflections.length;

  return (
    <div className="min-h-screen bg-stone-50 py-16 px-4 font-sans">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <h1 className="text-4xl font-light text-stone-900 mb-2">
            Your Wellness Dashboard
          </h1>
          <p className="text-stone-500 text-lg font-light">
            Insights cultivated from {totalReflections} reflection{totalReflections !== 1 ? 's' : ''}
          </p>
        </div>

        {/* Analytics Components */}
        <Analytics logs={reflections} />

      </div>
    </div>
  );
}
